import { configureStore } from '@reduxjs/toolkit';

import { areasReducer } from './areas';
import { userReducer } from './user';
import { mapReducer } from './map';
import { interfaceReducer } from './interface';
import { chartReducer } from './chart';
import { unitsApi } from './units';
import { fieldsApi } from './fields';
import { reviewApi } from './review';

export const store = configureStore({
  reducer: {
    areas: areasReducer,
    user: userReducer,
    map: mapReducer,
    interface: interfaceReducer,
    chart: chartReducer,
    [unitsApi.reducerPath]: unitsApi.reducer,
    [fieldsApi.reducerPath]: fieldsApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(
      unitsApi.middleware,
      fieldsApi.middleware,
      reviewApi.middleware
    )
});
